function storeJson(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value ?? null));
    return value ?? null;
}

function readJson(key) {
    try {
        return JSON.parse(sessionStorage.getItem(key));
    } catch (error) {
        return null;
    }
}

const PREFIX = 'prof_profile_';

export default {
    storePatient(patient) {
        return storeJson(PREFIX + 'patient', patient);
    },
    get patient() {
        return readJson(PREFIX + 'patient');
    },
    storeProfessional(professional) {
        if (!professional) {
            return storeJson(PREFIX + 'professional', null);
        }
        const { place_logo, availability_dates, ...rest } = professional;
        return storeJson(PREFIX + 'professional', rest);
    },
    get professional() {
        return readJson(PREFIX + 'professional');
    },
    storeAvailabilityTime(availabilityTime) {
        return storeJson(PREFIX + 'availability_time', availabilityTime);
    },
    get availabilityTime() {
        return readJson(PREFIX + 'availability_time');
    },
    storeInsurance(insurance) {
        delete insurance?.created_at;
        delete insurance?.updated_at;
        delete insurance?.ordering;
        delete insurance?.trading_name;
        delete insurance?.active;
        delete insurance?.nick_name;
        return storeJson(PREFIX + 'insurance', insurance);
    },
    get insurance() {
        return readJson(PREFIX + 'insurance');
    },
    storePaymentMethod(paymentMethod) {
        delete paymentMethod?.additional_information;
        delete paymentMethod?.allow_first_schedule;
        return storeJson(PREFIX + 'payment_method', paymentMethod);
    },
    get paymentMethod() {
        return readJson(PREFIX + 'payment_method');
    },
    storeSpecialty(specialty) {
        delete specialty?.spec_details;
        return storeJson(PREFIX + 'specialty', specialty);
    },
    get specialty() {
        return readJson(PREFIX + 'specialty');
    },
    storeCity(city) {
        delete city?.created_at;
        delete city?.updated_at;
        return storeJson(PREFIX + 'city', city);
    },
    get city() {
        return readJson(PREFIX + 'city');
    },
    storeCancelingPolicy(cancelingPolicy) {
        return storeJson(PREFIX + 'canceling_policy', cancelingPolicy);
    },
    get cancelingPolicy() {
        return readJson(PREFIX + 'canceling_policy');
    },
    storePixData(pixData) {
        return storeJson(PREFIX + 'pix_data', pixData);
    },
    get pixData() {
        return readJson(PREFIX + 'pix_data');
    },
    storePlan(plan) {
        return storeJson(PREFIX + 'plan', plan);
    },
    get plan() {
        return readJson(PREFIX + 'plan');
    },
    storePlaceColor(color) {
        return storeJson(PREFIX + 'place_color', color);
    },
    get placeColor() {
        return readJson(PREFIX + 'place_color');
    },
};
